// this twig template is only used for preview
// we send NewDirect header info and logo url by using variables
export const headerTwigTemplate: string = `
    <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="100%"
        bgcolor="ffffff"
        style="
            color:#000000;
            font-family: Arial, Helvetica, sans-serif;
            font-weight:700;
            margin: 10px 3px 0 3px;
        "
        id="preBody.header.1"
    >
        <tr>
            <td style="font-size:1.75rem; font-weight:700;">{{ data.headline }}</td>
        </tr>
        <tr>
            <td style="font-size:1.25rem; font-weight:700;">{{ data.subHeadline }}</td>
        </tr>
        <tr>
        </tr>
    </table>
    <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="100%"
        bgcolor="ffffff"
        style="
            color:#5e6473;
            font-family: Arial, Helvetica, sans-serif;
            font-size:0.688rem;
            font-weight:700;
            padding-top: 20px;
            margin: 10px 3px 0 3px;
        "
        id="preBody.header.2"
    >
        <tr>
            <td width="60%">{{ data.companyName }}</td>
            <td width="40%" style="text-align:end; padding-right:10px">{{ data.dateline }}</td>
        </tr>
    </table>
`;

// this twig template is only used for preview
// we send NewDirect header info and logo url by using variables
export const companyLogoTwigTemplate: string = `
    <div id="preBody.companyLogo" style="height: 120px; wdith: 120px;">
        <img src="{{ data.url }}" style="width: 120px;" />
    </div>
`;

export const companyAddressTwigTemplate: string = `
    <p style="
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 700;
        padding: 10px 0 5px 3px;
        color: #13224b;
        border-top: 1px solid #c7c7c7;
        font-size: 1rem;
        line-height: 1.3;
        margin: 0;
        "
    >Company Address</p>
    <p style="
        font-family: Arial, Helvetica, sans-serif;
        padding-left: 3px;
        color: #13224b;
        font-size: 1rem;
        line-height: 1.3;
        text-align: justify;
        margin: 0;
        "
    >{{ data.preText }}</p>
    <p style="
        font-family: Arial, Helvetica, sans-serif;
        padding-left: 3px;
        color: #13224b;
        font-size: 1rem;
        line-height: 1.3;
        text-align: justify;
        margin: 0;
        "
    >{{ data.street }}</p>
    <p style="
        font-family: Arial, Helvetica, sans-serif;
        padding-left: 3px;
        color: #13224b;
        font-size: 1rem;
        line-height: 1.3;
        text-align: justify;
        margin: 0;
        "
    >{{ data.city }} {{ data.state }} {{ data.postalCode }}</p>
    <p style="
        font-family: Arial, Helvetica, sans-serif;
        padding-left: 3px;
        color: #13224b;
        font-size: 1rem;
        line-height: 1.3;
        text-align: justify;
        margin: 0;
        "
    >{{ data.country }}</p>
    <p style="margin: 0;">&nbsp;</p>
`;
